import React, { createContext, useContext, FC, useState } from 'react';

export type InputMode =
    | 'enabled' // 'faqMode'
    | 'disabled'; //'triageMode';

export const InputModeContext = createContext<{
    inputMode: InputMode;
    setInputMode: (inputMode: InputMode) => void;
}>({
    inputMode: 'disabled',
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setInputMode: () => {},
});

export const InputModeProvider: FC<{
    initialMode: InputMode;
    children: React.ReactNode;
}> = ({ initialMode, children }) => {
    const [mode, setMode] = useState(initialMode);
    return (
        <InputModeContext.Provider
            value={{
                inputMode: mode,
                setInputMode: setMode,
            }}
        >
            {children}
        </InputModeContext.Provider>
    );
};

export const useInputMode = () => useContext(InputModeContext);
